import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline, sfImage, sfSub } from './sectionHelpers';

const CtaSplit: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const variant = c.variant || 'light';
  const imagePosition = c.image_position || 'right';

  const sectionBg =
    variant === 'dark'     ? '#0f172a' :
    variant === 'gradient' ? 'linear-gradient(135deg, var(--brand-primary, #1a365d) 0%, var(--brand-secondary, #2563eb) 100%)' :
    '#fff';

  const textColor = variant === 'light' ? '#0f172a' : '#fff';
  const subColor  = variant === 'light' ? 'var(--brand-text-light, #64748b)' : 'rgba(255,255,255,0.8)';

  const btnBg    = variant === 'light' ? 'var(--brand-primary, #2563eb)' : '#fff';
  const btnColor = variant === 'light' ? '#fff' : 'var(--brand-primary, #1a365d)';

  const isGradient = sectionBg.startsWith('linear-gradient');

  const imageCol = (
    <div style={{ flex: '1 1 45%', minWidth: 0, maxHeight: 480, overflow: 'hidden', borderRadius: 'var(--brand-card-radius, 12px)' }}>
      {sfImage(c) ? (
        <img
          src={sfImage(c)}
          alt={sfHeadline(c, '')}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <div style={{ width: '100%', height: '100%', minHeight: 320, background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
          Image
        </div>
      )}
    </div>
  );

  const textCol = (
    <div style={{ flex: '1 1 45%', minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 24 }}>
      <InlineEditText
        tag="h2"
        controlKey="headline"
        style={{ fontSize: '2.5rem', fontWeight: 800, lineHeight: 1.15, letterSpacing: '-0.025em', color: textColor, margin: 0 }}
      >
        {sfHeadline(c, 'Make Your Move')}
      </InlineEditText>

      <InlineEditText
        tag="p"
        controlKey="subheadline"
        style={{ fontSize: '1.125rem', lineHeight: 1.7, color: subColor, margin: 0 }}
      >
        {sfSub(c, 'Describe your offer and why it matters.')}
      </InlineEditText>

      <div>
        <a
          href={sfCtaUrl(c)}
          className="sb-cta-btn"
          style={{
            display: 'inline-block',
            padding: '16px 36px',
            borderRadius: 'var(--brand-btn-radius, 6px)',
            background: btnBg,
            color: btnColor,
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1rem',
            boxShadow: '0 4px 14px rgba(0,0,0,0.12)',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
        >
          <InlineEditText tag="span" controlKey="cta_text">
            {sfCtaText(c, 'Get Started')}
          </InlineEditText>
        </a>
      </div>
    </div>
  );

  return (
    <section
      className="sb-render sb-render-cta-split"
      style={{
        ...(isGradient ? { background: sectionBg } : { backgroundColor: sectionBg }),
        padding: '80px 24px',
      }}
    >
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 48,
        alignItems: 'center',
      }}>
        {imagePosition === 'left' ? (
          <>{imageCol}{textCol}</>
        ) : (
          <>{textCol}{imageCol}</>
        )}
      </div>
    </section>
  );
};

export default CtaSplit;
